import { render, staticRenderFns } from "./PagamentoCollapse.vue?vue&type=template&id=354d27f2&scoped=true"
import script from "./PagamentoCollapse.vue?vue&type=script&lang=js"
export * from "./PagamentoCollapse.vue?vue&type=script&lang=js"
import style0 from "./PagamentoCollapse.vue?vue&type=style&index=0&id=354d27f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354d27f2",
  null
  
)

export default component.exports